/**
 * Footer Component
 * Modern glass morphism footer with enhanced styling and responsive design
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES, APP_CONFIG } from '../../config';
import { useSafeThemeClasses } from '@/shared/theme';
import { data, formatCopyright } from '@/content/data';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const theme = useSafeThemeClasses();

  return (
    <footer className={`${theme.footer} mt-auto py-8`}>
      <div className="max-w-6xl mx-auto px-6">
        {/* Single row layout - minimal and clean */}
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          
          {/* Left side - Copyright */}
          <div className="text-center md:text-left">
            <p className={`text-sm ${theme.textMuted}`}>
              {formatCopyright(data.footer.copyrightTemplate, currentYear, APP_CONFIG.name)}
            </p>
          </div>

          {/* Right side - Simple links */}
          <div className="flex items-center space-x-6">
            <Link 
              to={ROUTES.ABOUT} 
              className={`text-sm ${theme.textMuted} hover:${theme.textPrimary} transition-colors duration-200`}
            >
              {data.footer.linkAbout}
            </Link>
            <Link 
              to={ROUTES.PROJECTS} 
              className={`text-sm ${theme.textMuted} hover:${theme.textPrimary} transition-colors duration-200`}
            >
              {data.footer.linkProjects}
            </Link>
            <Link 
              to={ROUTES.BLOG} 
              className={`text-sm ${theme.textMuted} hover:${theme.textPrimary} transition-colors duration-200`}
            >
              {data.footer.linkBlog}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
